export enum MultiOrderNotice {
  NO_NON_LEVERAGED_DERIVATIVES_EXPERIENCE = 'NO_NON_LEVERAGED_DERIVATIVES_EXPERIENCE',
  NO_LEVERAGED_DERIVATIVES_EXPERIENCE = 'NO_LEVERAGED_DERIVATIVES_EXPERIENCE',
  NO_FTG = 'NO_FTG',
  NO_FTG_BUT_ALLOWED_TO_ACTIVATE = 'NO_FTG_BUT_ALLOWED_TO_ACTIVATE',
}
